const parallelcoordinatesdata = [
    {
        "temp": -9,
        "cost": 48880,
        "color": "red",
        "target": "D",
        "volume": 5.420347151600472
    },
    {
        "temp": 34,
        "cost": 144267,
        "color": "red",
        "target": "C",
        "volume": 7.391015650719306
    },
    {
        "temp": 38,
        "cost": 240796,
        "color": "green",
        "target": "A",
        "volume": 4.483194660801151
    },
    {
        "temp": 16,
        "cost": 346859,
        "color": "green",
        "target": "B",
        "volume": 5.515453047906635
    },
    {
        "temp": 14,
        "cost": 245636,
        "color": "red",
        "target": "D",
        "volume": 4.51201362842311
    },
    {
        "temp": 32,
        "cost": 322275,
        "color": "yellow",
        "target": "C",
        "volume": 1.7627759450824605
    },
    {
        "temp": 28,
        "cost": 237271,
        "color": "red",
        "target": "B",
        "volume": 0.6423614160478939
    },
    {
        "temp": 10,
        "cost": 28785,
        "color": "red",
        "target": "A",
        "volume": 4.581303259525245
    },
    {
        "temp": -8,
        "cost": 357663,
        "color": "yellow",
        "target": "E",
        "volume": 5.788227900910585
    },
    {
        "temp": 30,
        "cost": 19499,
        "color": "green",
        "target": "A",
        "volume": 3.551929182883994
    },
    {
        "temp": 32,
        "cost": 12278,
        "color": "green",
        "target": "E",
        "volume": 4.1286375721486275
    },
    {
        "temp": 30,
        "cost": 230598,
        "color": "yellow",
        "target": "D",
        "volume": 0.7370561391680304
    },
    {
        "temp": 0,
        "cost": 288098,
        "color": "yellow",
        "target": "A",
        "volume": 4.016502909488248
    },
    {
        "temp": 21,
        "cost": 329497,
        "color": "red",
        "target": "D",
        "volume": 3.1260699431899353
    },
    {
        "temp": -1,
        "cost": 86889,
        "color": "red",
        "target": "D",
        "volume": 4.101758039297146
    },
    {
        "temp": 12,
        "cost": 326823,
        "color": "green",
        "target": "C",
        "volume": 7.0583760189599065
    },
    {
        "temp": 15,
        "cost": 121708,
        "color": "green",
        "target": "E",
        "volume": 4.959790056852775
    },
    {
        "temp": 33,
        "cost": 77045,
        "color": "yellow",
        "target": "C",
        "volume": 3.4932208571706855
    },
    {
        "temp": 4,
        "cost": 334205,
        "color": "red",
        "target": "D",
        "volume": 3.672312377840396
    },
    {
        "temp": -7,
        "cost": 13858,
        "color": "red",
        "target": "D",
        "volume": 0.5619628824510134
    },
    {
        "temp": 22,
        "cost": 50165,
        "color": "yellow",
        "target": "A",
        "volume": 0.39994078505345576
    },
    {
        "temp": 13,
        "cost": 88765,
        "color": "yellow",
        "target": "B",
        "volume": 6.85852852969061
    },
    {
        "temp": 34,
        "cost": 340640,
        "color": "yellow",
        "target": "C",
        "volume": 0.2819176594552607
    },
    {
        "temp": -7,
        "cost": 215707,
        "color": "green",
        "target": "A",
        "volume": 3.526739014327537
    },
    {
        "temp": 19,
        "cost": 212277,
        "color": "green",
        "target": "E",
        "volume": 6.794819251447413
    },
    {
        "temp": 28,
        "cost": 220693,
        "color": "red",
        "target": "A",
        "volume": 2.81856506110202
    },
    {
        "temp": 39,
        "cost": 395223,
        "color": "red",
        "target": "A",
        "volume": 5.654077853849223
    },
    {
        "temp": -9,
        "cost": 240176,
        "color": "red",
        "target": "A",
        "volume": 3.533211624432891
    },
    {
        "temp": 27,
        "cost": 378354,
        "color": "green",
        "target": "E",
        "volume": 6.938375894684491
    },
    {
        "temp": 32,
        "cost": 224706,
        "color": "yellow",
        "target": "C",
        "volume": 0.8791550566368598
    },
    {
        "temp": 11,
        "cost": 106232,
        "color": "yellow",
        "target": "C",
        "volume": 2.3179278437728956
    },
    {
        "temp": -1,
        "cost": 87262,
        "color": "red",
        "target": "B",
        "volume": 6.175279046609562
    }
]
export default parallelcoordinatesdata;